(function () {
  function scrollToReviews(behavior) {
    var target = document.querySelector('#roji-customer-reviews');
    if (!target) return;
    var offset = window.matchMedia('(max-width: 768px)').matches ? 80 : 110;
    window.scrollTo({
      top: target.getBoundingClientRect().top + window.pageYOffset - offset,
      behavior: behavior
    });
  }

  function stabilizeReviewPosition(initialBehavior) {
    scrollToReviews(initialBehavior || 'auto');
    [600, 1800, 3600, 6000, 9000].forEach(function (delay) {
      window.setTimeout(function () { scrollToReviews(delay === 600 ? 'smooth' : 'auto'); }, delay);
    });
  }

  document.addEventListener('click', function (event) {
    var clicked = event.target instanceof Element ? event.target : event.target.parentElement;
    var link = clicked && clicked.closest('a.roji-product-rating');
    if (!link) return;
    if (!document.querySelector('#roji-customer-reviews')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (window.location.hash !== '#roji-customer-reviews') {
      window.history.pushState(null, '', '#roji-customer-reviews');
    }
    stabilizeReviewPosition('smooth');
  }, true);

  window.addEventListener('load', function () {
    if (window.location.hash === '#roji-customer-reviews') {
      stabilizeReviewPosition('auto');
    }
  });
})();
